let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("LgKUw")).then(() => parcelRequire('bsSEQ'));